// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/core/common.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";
import { file_proto_model_core_model_path } from "./model_path_pb";

/**
 * Describes the file proto/model/core/common.proto.
 */
export const file_proto_model_core_common = /*@__PURE__*/
  fileDesc("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", [file_proto_model_core_model_path]);

/**
 * Describes the message carmen.Climate.
 * Use `create(ClimateSchema)` to create a new message.
 */
export const ClimateSchema = /*@__PURE__*/
  messageDesc(file_proto_model_core_common, 0);

/**
 * Describes the message carmen.Ideology.
 * Use `create(IdeologySchema)` to create a new message.
 */
export const IdeologySchema = /*@__PURE__*/
  messageDesc(file_proto_model_core_common, 1);

/**
 * Describes the message carmen.ContentUpdateResult.
 * Use `create(ContentUpdateResultSchema)` to create a new message.
 */
export const ContentUpdateResultSchema = /*@__PURE__*/
  messageDesc(file_proto_model_core_common, 2);

/**
 * Describes the message carmen.PartySize.
 * Use `create(PartySizeSchema)` to create a new message.
 */
export const PartySizeSchema = /*@__PURE__*/
  messageDesc(file_proto_model_core_common, 3);

/**
 * Describes the enum carmen.Adventurousness.
 */
export const AdventurousnessSchema = /*@__PURE__*/
  enumDesc(file_proto_model_core_common, 0);

/**
 * Represents the willingness to try new and novel experiences
 *
 * @generated from enum carmen.Adventurousness
 */
export const Adventurousness = /*@__PURE__*/
  tsEnum(AdventurousnessSchema);

/**
 * Describes the enum carmen.Cuisine.
 */
export const CuisineSchema = /*@__PURE__*/
  enumDesc(file_proto_model_core_common, 1);

/**
 * Food-related enums used across multiple domains (restaurants, activities, places)
 *
 * @generated from enum carmen.Cuisine
 */
export const Cuisine = /*@__PURE__*/
  tsEnum(CuisineSchema);

/**
 * Describes the enum carmen.DietaryRestriction.
 */
export const DietaryRestrictionSchema = /*@__PURE__*/
  enumDesc(file_proto_model_core_common, 2);

/**
 * @generated from enum carmen.DietaryRestriction
 */
export const DietaryRestriction = /*@__PURE__*/
  tsEnum(DietaryRestrictionSchema);

/**
 * Describes the enum carmen.SpiceLevel.
 */
export const SpiceLevelSchema = /*@__PURE__*/
  enumDesc(file_proto_model_core_common, 3);

/**
 * @generated from enum carmen.SpiceLevel
 */
export const SpiceLevel = /*@__PURE__*/
  tsEnum(SpiceLevelSchema);

/**
 * Describes the enum carmen.FoodFacilityType.
 */
export const FoodFacilityTypeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_core_common, 4);

/**
 * Describes the facilities, not the cuisine or food.
 * cf. FoodAndDrinkPlaceType describes cuisine and food.
 *
 * @generated from enum carmen.FoodFacilityType
 */
export const FoodFacilityType = /*@__PURE__*/
  tsEnum(FoodFacilityTypeSchema);

/**
 * Describes the enum carmen.ApproximateTimeOfDay.
 */
export const ApproximateTimeOfDaySchema = /*@__PURE__*/
  enumDesc(file_proto_model_core_common, 5);

/**
 * Represents an approximate time of day that an activity or event takes place.
 * (All-day events are usually a separate flag.)
 *
 * @generated from enum carmen.ApproximateTimeOfDay
 */
export const ApproximateTimeOfDay = /*@__PURE__*/
  tsEnum(ApproximateTimeOfDaySchema);

/**
 * Describes the enum carmen.DayOfWeek.
 */
export const DayOfWeekSchema = /*@__PURE__*/
  enumDesc(file_proto_model_core_common, 6);

/**
 * @generated from enum carmen.DayOfWeek
 */
export const DayOfWeek = /*@__PURE__*/
  tsEnum(DayOfWeekSchema);

/**
 * Describes the enum carmen.EntityStatus.
 */
export const EntityStatusSchema = /*@__PURE__*/
  enumDesc(file_proto_model_core_common, 7);

/**
 * Base status enum for business entities (hotels, restaurants, etc.)
 * Provides common operational states that can be reused across entity types.
 *
 * @generated from enum carmen.EntityStatus
 */
export const EntityStatus = /*@__PURE__*/
  tsEnum(EntityStatusSchema);

/**
 * Describes the enum carmen.FinancialStatus.
 */
export const FinancialStatusSchema = /*@__PURE__*/
  enumDesc(file_proto_model_core_common, 8);

/**
 * Base status enum for financial operations (payments, invoices, refunds)
 * Provides common financial states that can be reused across payment-related entities.
 *
 * @generated from enum carmen.FinancialStatus
 */
export const FinancialStatus = /*@__PURE__*/
  tsEnum(FinancialStatusSchema);

/**
 * Describes the enum carmen.Frequency.
 */
export const FrequencySchema = /*@__PURE__*/
  enumDesc(file_proto_model_core_common, 9);

/**
 * @generated from enum carmen.Frequency
 */
export const Frequency = /*@__PURE__*/
  tsEnum(FrequencySchema);

/**
 * Describes the enum carmen.Importance.
 */
export const ImportanceSchema = /*@__PURE__*/
  enumDesc(file_proto_model_core_common, 10);

/**
 * Represents the importance level of a setting
 *
 * @generated from enum carmen.Importance
 */
export const Importance = /*@__PURE__*/
  tsEnum(ImportanceSchema);

/**
 * Describes the enum carmen.MeasurementUnit.
 */
export const MeasurementUnitSchema = /*@__PURE__*/
  enumDesc(file_proto_model_core_common, 11);

/**
 * @generated from enum carmen.MeasurementUnit
 */
export const MeasurementUnit = /*@__PURE__*/
  tsEnum(MeasurementUnitSchema);

/**
 * Describes the enum carmen.PriceLevel.
 */
export const PriceLevelSchema = /*@__PURE__*/
  enumDesc(file_proto_model_core_common, 12);

/**
 * @generated from enum carmen.PriceLevel
 */
export const PriceLevel = /*@__PURE__*/
  tsEnum(PriceLevelSchema);

/**
 * Describes the enum carmen.ProcessStatus.
 */
export const ProcessStatusSchema = /*@__PURE__*/
  enumDesc(file_proto_model_core_common, 13);

/**
 * Base status enum for processes and workflows
 * Provides common process states that can be reused across different workflows.
 *
 * @generated from enum carmen.ProcessStatus
 */
export const ProcessStatus = /*@__PURE__*/
  tsEnum(ProcessStatusSchema);

/**
 * Describes the enum carmen.RetrievalDepth.
 */
export const RetrievalDepthSchema = /*@__PURE__*/
  enumDesc(file_proto_model_core_common, 14);

/**
 * How to load subtrees of a document.
 *
 * @generated from enum carmen.RetrievalDepth
 */
export const RetrievalDepth = /*@__PURE__*/
  tsEnum(RetrievalDepthSchema);

/**
 * Describes the enum carmen.Severity.
 */
export const SeveritySchema = /*@__PURE__*/
  enumDesc(file_proto_model_core_common, 15);

/**
 * Represents the severity or importance level for general system operations.
 * Unified enum for validation, errors, and general severity classifications.
 *
 * @generated from enum carmen.Severity
 */
export const Severity = /*@__PURE__*/
  tsEnum(SeveritySchema);

/**
 * Describes the enum carmen.SyncStatus.
 */
export const SyncStatusSchema = /*@__PURE__*/
  enumDesc(file_proto_model_core_common, 16);

/**
 * Base status enum for data synchronization
 * Provides common sync states for distributed systems and data consistency.
 *
 * @generated from enum carmen.SyncStatus
 */
export const SyncStatus = /*@__PURE__*/
  tsEnum(SyncStatusSchema);

/**
 * Describes the enum carmen.TravelMode.
 */
export const TravelModeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_core_common, 17);

/**
 * Mode of transportation.
 *
 * @generated from enum carmen.TravelMode
 */
export const TravelMode = /*@__PURE__*/
  tsEnum(TravelModeSchema);

/**
 * Describes the enum carmen.TravelerType.
 */
export const TravelerTypeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_core_common, 18);

/**
 * Types of travelers for booking and pricing purposes.
 * Used across transportation, accommodations, and activities.
 *
 * @generated from enum carmen.TravelerType
 */
export const TravelerType = /*@__PURE__*/
  tsEnum(TravelerTypeSchema);

/**
 * Describes the enum carmen.TravelerProfile.
 */
export const TravelerProfileSchema = /*@__PURE__*/
  enumDesc(file_proto_model_core_common, 19);

/**
 * Traveler interest profiles for personalized recommendations.
 * Used across trip highlights, activities, and destination preferences.
 *
 * @generated from enum carmen.TravelerProfile
 */
export const TravelerProfile = /*@__PURE__*/
  tsEnum(TravelerProfileSchema);

/**
 * Describes the enum carmen.VisitDuration.
 */
export const VisitDurationSchema = /*@__PURE__*/
  enumDesc(file_proto_model_core_common, 20);

/**
 * Time investment required for visiting a location or activity.
 * Used for planning highlights, activities, and scheduling.
 *
 * @generated from enum carmen.VisitDuration
 */
export const VisitDuration = /*@__PURE__*/
  tsEnum(VisitDurationSchema);

